<template>
	<div class="login_container" @keydown.enter="getLogin">
		<vue-particles color="#dedede" :particleOpacity="0.7" :particlesNumber="150" shapeType="circle" :particleSize="4"
			linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.5" :linesDistance="150"
			:moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
		</vue-particles>
		<!-- <el-alert v-if="!sid" title="登录地址错误！" type="error" center show-icon :closable="false"> </el-alert> -->
		<div class="login_box">
			<!-- 头像区 -->
			<!-- <div class="avatar_box">
				<img src="../../assets/logo_.png" alt="avatar" />
			</div> -->
			<div class="title">
				<span>{{loginName}}</span>
			</div>
			<!-- 登录表单 -->
			<div>
				<el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="100px" class="login_form">
					<el-form-item label="账号" prop="username" class="bb">
						<el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password" v-show="type=='login'" class="bb">
						<el-input v-model="loginForm.password" type="password" placeholder="请输入密码"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="captcha" v-show="type=='login'" class="bb">
						<div class="row">
							<el-input class="input" v-model="loginForm.captcha" placeholder="请输入验证码"></el-input>
							<img :src="captchaImg" @click="getCaptcha">
						</div>
					</el-form-item>
                    <el-form-item label="短信验证码" prop="code" v-show="type=='forget'" class="bb">
						<el-input class="input" v-model="loginForm.code" type="password" placeholder="请输入短信验证码"></el-input>
                        <span @click="send" style="cursor: pointer;" :style="{color: time > 0 ? '#999' : 'rgb(102, 177, 255)'}">发送短信 <span v-show="time > 0">({{time}})</span></span>
					</el-form-item>
					<el-form-item label="新密码" prop="password" v-show="type=='forget'" class="bb">
						<el-input class="input_" v-model="loginForm.password" type="password" placeholder="请输入新密码"></el-input>
					</el-form-item>
                    <div style="cursor: pointer;text-align: right;margin: 0 20px 10px 0;font-size: 16px;color: #999;" v-show="type=='login'" @click="type='forget'">忘记密码</div>
                    <div style="cursor: pointer;text-align: right;margin: 0 20px 10px 0;font-size: 16px;color: #999;" v-show="type=='forget'" @click="type='login'">立即登录</div>
					<el-form-item label-width="0" class="btns">
						<el-button type="primary" @click="getLogin" style="width: 300px;" v-if="type == 'login'">登录</el-button>
                        <el-button type="primary" @click="getForget" style="width: 300px;" v-else>确定</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="footer">
			©版权所有 2023-2025 
			|
			推荐使用 Google Chrome 或 Microsoft Edge 浏览器访问
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions, mapMutations } from 'vuex';
	import { loginCaptcha, adminLogin, autoLoginByAccount, index, sms, forgetLogin, loginConfig } from "../../request/apis.js"
    import store from "../../store/index.js"
	export default {
		data() {
			return {
                loginName: '品牌商管理系统',
                type: 'login',
                time: 0,
                timer: null,
				captchaImg: '',
				loginForm: {
					username: '',
					password: '',
					captcha: ''
				},
				// 表单验证
				loginFormRules: {
					username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
						{ min: 11, max: 11, message: '长度为11个字符', trigger: 'blur' }
					],
					password: [
                        { required: true, message: '请输入用户密码', trigger: 'blur' },
						{ min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
					],
					captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' } ],
                    code: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
				}
			}
		},
		computed: {
			...mapGetters(['loginInfo']),
		},
		mounted() {
			sessionStorage.clear()
            this.getLoginName();
			// this.clearToken();
			this.getCaptcha();

            console.log(this.$route.query)
            var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
            if(loginInfo == null){
                loginInfo = store.state.loginInfo;
            }
            // 检查用户是否已登录
            if (!loginInfo.token && this.$route.query.ticket){
                console.log('autologin', this.$route.query)
                autologin({ticket: this.$route.query.ticket}).then(res => {
                    console.log('autologin res', res)
					if (res.code == 0) {
						this.setLoginInfo(res.data);
						this.$router.push('/home')
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err => {})
            }
		},
		methods: {
			...mapActions(['setLoginInfo']),
			...mapMutations(['clearToken']),
			/**
			 * 获取验证码
			 */
			getCaptcha() {
				loginCaptcha().then(res => {
					if (res.code == 0) {
						this.loginForm.captcha = '';
						this.captchaImg = res.data.captcha;
					}
				}).catch(err => {})
			},

			/**
			 * 登录
			 */
			getLogin() {
				adminLogin({
					...this.loginForm
				}).then(res => {
					if (res.code == 0) {
						this.setLoginInfo(res.data);
						this.$router.push('/home')
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},
            async getForget(){
                let res = await forgetLogin(this.loginForm);
                if(res.code === 0){
                    this.$message.success(res.msg || '操作成功');
                    this.setLoginInfo(res.data);
					this.$router.push('/home')
                }else{
                    return this.$message.error(res.msg || '操作失败');
                }
            },
            async send(){
                if(this.time > 0){
                    return;
                }
                if(!this.loginForm.username){
                    return this.$message.error('请先输入手机账号');
                }
                let res = await sms({phone: this.loginForm.username});
                if(res.code === 0){
                    this.time = 60;
                    this.timer = setInterval(() => { 
                        if(this.time <= 0){
                            clearInterval(this.timer);
                        }
                        this.time = this.time - 1;
                    }, 1000);
                    return this.$message.success('发送成功');
                }else{
                    return this.$message.error(res.msg || '发送失败');
                }
            },
            async getLoginName(){
                let loginName = localStorage.getItem('system_login_name');
                if(loginName){
                    this.loginName = loginName;
                }else{
                    console.log('getLoginName', this.$route, location)
                    if(this.$route.query.sid){
                        let res = await loginConfig({sid: this.$route.query.sid});
                        if(res.code === 0 && res.data.system_login_name){
                            this.loginName = res.data.system_login_name;
                        }
                    }
                }
            }
		}
	}
</script>

<style scoped>
    input, input:focus {
        border: none !important;
        outline: none !important; 
    }
    /deep/ .el-input__inner {
        border: none !important;    
    }
    /deep/ .el-form-item__label {
        text-align: left;
    }
    .bb{
        border-bottom: 1px solid #99999945;
    }
	.login_container {
		background-color: #2b4b6b;
		height: 100%;
	}

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.login_box {
		width: 450px;
		height: 430px;
		background-color: #fff;
		border-radius: 10px;
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		background-color: #fff;
	}

	.login_box .avatar_box {
		width: 130px;
		height: 130px;
		border: 1px solid #eee;
		border-radius: 50%;
		padding: 10px;
		box-shadow: 0 0 10px #ddd;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #fff;
	}

	.title {
        margin-top: 50px;
		font-size: 24px;
        text-align: center;
		font-weight: bolder;
	}

	.input_ {
		width: 310px;
	}

	.input {
		width: 200px;
		margin-right: 10px;
	}

	.login_box .avatar_box img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: #eee;
	}

	.login_form {
		position: absolute;
		bottom: 20px;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.btns {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.info {
		font-size: 13px;
		margin: 10px 15px;
	}

	.footer {
		position: absolute;
		bottom: 0px;
		width: 100%;
		text-align: center;
		color: #999;
	}
</style>